import * as React from 'react';

import { CheckMarkIcon } from '../Icons/CheckMarkIcon';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';
import { IDB } from '../../helpers/directBookingHelper';
import { __ } from '../../helpers/TranslationService';
import { config } from '../../config';

interface IRequestFormButtons {
    showLastCheckMark?: boolean;
    buttonsConfig: IDB;
    directBookingUrl: string;
    onBoardCredit: number;
    onRequest: boolean;
    validatePersonalForm?: () => void;
}
export const RequestFormButtons = (props: IRequestFormButtons) => {
    const {
        buttonsConfig,
        directBookingUrl,
        onRequest,
        showLastCheckMark,
        validatePersonalForm,
    } = props;

    return (
        <>
            <div id="requestFormContainer__actions">
                {(buttonsConfig.shouldShowRequestNow || onRequest) && (
                    <div className="requestFormContainer__actions__unit">
                        <button
                            onClick={validatePersonalForm}
                            data-testid="request-now-button"
                            className="blue_button darker_blue has_hover w-100"
                        >
                            {__('buttons.buttonText', 'dreamlines')}

                            <ArrowRightIcon
                                className="requestForm__actionButtonIcon"
                                width={16}
                                height={16}
                            />
                        </button>

                        <ul className="requestFormContainer__actions__unit__list">
                            <li>
                                <CheckMarkIcon width="13" height="13" />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: __('request.CTARequestButtonRow1', 'dreamlines'),
                                    }}
                                ></span>
                            </li>
                            <li>
                                <CheckMarkIcon width="13" height="13" />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: __('request.CTARequestButtonRow2', 'dreamlines'),
                                    }}
                                ></span>
                            </li>
                            {showLastCheckMark && (
                                <li>
                                    <CheckMarkIcon width="13" height="13" />
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: __(
                                                'request.CTARequestButtonRow3',
                                                'dreamlines',
                                            ),
                                        }}
                                    ></span>
                                </li>
                            )}
                        </ul>
                    </div>
                )}
                {buttonsConfig.shouldShowDirectBooking && (
                    <div className="requestFormContainer__actions__unit">
                        <a href={directBookingUrl}>
                            <button
                                data-testid="direct-booking-button"
                                className="blue_button has_hover w-100"
                            >
                                {__('request.directButtonText', 'dreamlines')}
                                <ArrowRightIcon
                                    className="requestForm__actionButtonIcon"
                                    width={16}
                                    height={16}
                                />
                            </button>
                        </a>
                        <ul className="requestFormContainer__actions__unit__list">
                            <li>
                                <CheckMarkIcon width="14" height="14" />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: `${__(
                                            'request.CTADirectButtonRow1',
                                            'dreamlines',
                                        )}`,
                                    }}
                                ></span>
                            </li>
                            <li>
                                <CheckMarkIcon width="14" height="14" />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: __('request.CTADirectButtonRow2', 'dreamlines'),
                                    }}
                                ></span>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
            <div id="requestFormContainer__ssl-label">
                <img
                    src={`${config.images}/common/ssl.png`}
                    alt={__('request.sslText', 'dreamlines')}
                />
                <p>
                    <b>{__('request.sslText', 'dreamlines')}</b>
                </p>
            </div>
        </>
    );
};
